import { Text,useToast } from '@chakra-ui/react'
import { useEffect, useMemo, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getAllUsers } from '../../classes/User'
import { useSearchQueryContext } from '../../context/searchQueryContext'
import SelectedItemAlertContext, { AL_INFO, AL_RESET_PASSWORD, defaultSelectData } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { BadgeUserRole, BadgeUserStatus, Table, TableButtonUsersGroup } from '../shared'
import ModalUserInfo from './ModalUserInfo'
import ModalUserResetPassword from './ModalUserResetPassword'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableAllUsers = () => {
    const toast = useToast()
    const { userData } = useUserContext()
    const columns = useMemo(() => [
        {
            Header: '#',
            Cell: ({ row }) => (<Text>{row.index + 1}</Text>)
        },
        {
            Header: 'ชื่อบัญชี',
            accessor: 'username',
        },
        {
            Header: 'ชื่อ',
            accessor: 'first_name',
        },
        {
            Header: 'นามสกุล',
            accessor: 'last_name',
        },
        {
            Header: 'หน่วยงาน',
            accessor: 'office_name',
        },
        {
            Header: 'สิทธิ์',
            Cell: ({ row }) => <BadgeUserRole data={row.original} />
        },
        {
            Header: 'สถานะ',
            accessor: 'status',
            Cell: ({ value }) => <BadgeUserStatus status={value} />
        },
        {
            Header: 'จัดการ',
            Cell: ({ row }) => <TableButtonUsersGroup row={row.original} />
        },
    ], [])

    const [data, setData] = useState(null)
    const [itemData, setItemData] = useState(defaultSelectData)
    const loadData = useRef()
    const { query } = useSearchQueryContext()
    loadData.current = async () => {
        // console.log(query)
        await getAllUsers(query, userData.token)
            .then(res => {
                // console.log(res)
                setData(res)
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [query, itemData?.reload])

    return (
        <SelectedItemAlertContext.Provider value={[itemData, setItemData]}>
            {data && <Table columns={columns} data={data} />}
            {itemData?.type === AL_INFO && <ModalUserInfo data={itemData} />}
            {itemData?.type === AL_RESET_PASSWORD && <ModalUserResetPassword data={itemData} />}
        </SelectedItemAlertContext.Provider>
    )
}

export default TableAllUsers
